export default __webpack_public_path__ + "static/media/areaCobertura.86407ed1.png";